module.exports = __webpack_public_path__ + "static/media/bbsul.45ce397c.png";